'use strict';

import type { IndAlternateId } from '../../Entities/Ind/IndAlternateId';
import { EntityCollection } from '../EntityCollection';

export class IndAlternateIdCollection extends EntityCollection<IndAlternateId> {}
